
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

const SubscriptionTab = () => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Ditt abonnemang</CardTitle>
        <CardDescription>
          Hantera ditt abonnemang på Snabbaupphandlingar
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-start space-x-3">
            <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 shrink-0" />
            <div>
              <h3 className="font-medium text-green-700">Aktivt abonnemang</h3>
              <p className="text-sm text-green-600 mt-1">
                Du har för närvarande ett standardabonnemang som förnyas automatiskt den 1 juli 2023.
              </p>
            </div>
          </div>
          
          <div className="border rounded-lg overflow-hidden">
            <div className="bg-gray-50 px-4 py-3 border-b">
              <h3 className="font-medium">Abonnemangsdetaljer</h3>
            </div>
            <div className="p-4 space-y-4">
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">Plan</div>
                <div className="font-medium">Standard</div>
              </div>
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">Pris</div>
                <div className="font-medium">349 kr/månad</div>
              </div>
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">Förnyelsedatum</div>
                <div className="font-medium">1 juli 2023</div>
              </div>
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">Analyser per månad</div>
                <div className="font-medium">20</div>
              </div>
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">Analyser kvar</div>
                <div className="font-medium">17</div>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
            <Button variant="outline" onClick={() => navigate('/priser')}>
              Uppgradera abonnemang
            </Button>
            <Button variant="ghost" className="text-red-600 hover:text-red-700 hover:bg-red-50">
              Avsluta abonnemang
            </Button>
          </div>
          
          <div className="border-t pt-6">
            <h3 className="text-lg font-medium mb-4">Fakturahistorik</h3>
            <div className="border rounded-lg overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Datum</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Belopp</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Faktura</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  <tr>
                    <td className="px-4 py-3 text-sm">2023-05-01</td>
                    <td className="px-4 py-3 text-sm">349 kr</td>
                    <td className="px-4 py-3 text-sm">
                      <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        Betald
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-blue-600 hover:underline cursor-pointer">
                      Ladda ner
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-sm">2023-04-01</td>
                    <td className="px-4 py-3 text-sm">349 kr</td>
                    <td className="px-4 py-3 text-sm">
                      <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        Betald
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-blue-600 hover:underline cursor-pointer">
                      Ladda ner
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubscriptionTab;
